import React, { Component } from 'react';
import { Row } from 'reactstrap';
import styled from 'styled-components';

// components
import Card from './Card';

export default class CardDeck extends Component {
    constructor(props) {
        super(props);
        this.state = {
            turned: false,
        }
        this.Body = React.createRef();
    }

    componentDidMount() {
        if (this.Body.current.clientWidth < 800) {
            this.setState({ turned: true })
        }
    }

    render() {
        const { cards } = this.props;
        const { turned } = this.state;
        return (
            <DeckWrap ref={this.Body} >
                <FlexRow>
                    {cards.map((card, i) => {
                        return (
                            <Card
                                turned={turned}
                                color={card.color}
                                frontLogo={card.frontLogo}
                                backLogo={card.backLogo}
                                text={card.text}
                                link={card.link}
                                key={i * 23} />
                        );
                    })}
                </FlexRow>
            </DeckWrap>
        );
    }
}

const FlexRow = styled(Row)`
    flex-direction: row;
    -ms-flex-direction: row;
    @media screen and (max-width: 1000px) {
        flex-direction: column;
        -ms-flex-direction: row;
    }
`;

const DeckWrap = styled.div`
    width: 80%;
    margin: 0 10% 0 10%;
    @media screen and (max-width: 1200px) {
        width: 90%;
        margin: 0 5% 0 5%;
    }
`;